import { clearReportScopeDataCache } from '../features/report/context/reportScopeDataCache';
import { clearCachedReportTargets } from '../features/auth/utils/reportTargetCache';

export const OAUTH_REDIRECT_IN_PROGRESS_KEY = 'oauth_redirect_in_progress';

const localStorageSessionKeys = [
  'auth_state',
  'auth_error',
  'post_login_page',
  'post_spiris_connect_page',
  'all_access_profile_selected',
  'all_access_target_selected',
];

const sessionStorageSessionKeys = [
  OAUTH_REDIRECT_IN_PROGRESS_KEY,
  'company_switch_in_progress',
  'report_statuses_v3',
];

type CleanupOptions = {
  authError?: string;
};

export const clearFrontendSessionState = (options: CleanupOptions = {}) => {
  localStorageSessionKeys.forEach((key) => localStorage.removeItem(key));
  sessionStorageSessionKeys.forEach((key) => sessionStorage.removeItem(key));
  clearReportScopeDataCache();
  clearCachedReportTargets();

  if (options.authError) {
    localStorage.setItem('auth_error', options.authError);
  }
};